module.exports = __webpack_public_path__ + "img/ghana.288d53c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/ghana.jpg
// module id = 1866
// module chunks = 1